import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: "Pesanan gagal diterima",
        message: "Pesanan telah dibatalkan customer Anda.",
        image: "ill_badge_failed",
        textCancel: "Kembali",
        class: "px-8",
        customWidth: "417px",
        customWrapperButton: "w-80",
        isButtonFull: true,
        onClose: _ctx.onCloseModal,
        onSubmit: _ctx.onRetryModal,
        idButtonCancel: "button_back_modal_success_accept_order",
        idButtonSuccess: "button_retry_modal_success_accept_order"
      }, null, 8, ["onClose", "onSubmit"]))
    : _createCommentVNode("", true)
}